import React, { useContext } from "react";
import { FiChevronLeft } from "react-icons/fi";
import { Button } from "../Button";
import { FEEDBACK_PREVIEW_INDEX } from "@/utils/feedbackPreviewNavigation";
import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

export const FeedbackNavigation = ({ buttonColor, hasMultipleCategories }) => {
  const qrFeedbackContextData =
    useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { currentView, setCurrentView } = qrFeedbackContextData;

  const handleFeedbackBackNav = () => {
    if (currentView === FEEDBACK_PREVIEW_INDEX.ADD_INFO) {
      setCurrentView(
        hasMultipleCategories
          ? FEEDBACK_PREVIEW_INDEX.HOME_MULTIPLE_CATEGORIES
          : FEEDBACK_PREVIEW_INDEX.HOME_SINGLE_CATEGORY
      );
    } else {
      setCurrentView(currentView - 1);
    }
  };

  return (
    <div className="feedback-navigation">
      <Button
        ghost
        iconLeft
        dataQA="feedback-back-button"
        icon={<FiChevronLeft />}
        label={"Back"}
        onClick={() => handleFeedbackBackNav()}
        buttonColor={buttonColor}
      />
    </div>
  );
};
